import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var actionSymbols = {
  replace: Symbol("replace")
};
var allActions = Object.keys(actionSymbols);
var allSymbols = Object.values(actionSymbols);
export var makeReduceActions = function makeReduceActions() {
  return Object.entries(actionSymbols).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      symbol = _ref2[1];
    return Object.assign(acc, _defineProperty({}, key, function (state) {
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, symbol, true));
    }));
  }, {});
};
var getActiveAction = function getActiveAction(inputState) {
  return allActions.find(function (action) {
    var s = actionSymbols[action];
    if (s in inputState) return true;
  });
};
export var reduceState = function reduceState(state, inputState) {
  if (!inputState || typeof inputState !== "object") return state;
  var procState = inputState;
  var action = getActiveAction(inputState);
  allSymbols.forEach(function (s) {
    procState[s] && delete procState[s];
  });
  switch (action) {
    case "replace":
      {
        return _objectSpread({}, procState);
      }
    default:
      {
        return _objectSpread(_objectSpread({}, state), procState);
      }
  }
};